const Target = require('../../../../model/Target');
require('./targetAddEditDialog.style.scss');

class TargetAddEditDialogController {
    constructor($scope, $filter, $timeout, utilsService, principalService, notificationService, targetsPersistence, storageService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.utilsService = utilsService;
        this.principalService = principalService;
        this.notificationService = notificationService;
        this.targetsPersistence = targetsPersistence;
        this.$timeout = $timeout;
        this.storageService = storageService;
        this.modalTitle = this.$filter('translate')('target.new.title');
        this.searchPlaceholder = this.$filter('translate')('target.new.placeholder');
        this.selectedTarget = [];
        this.emptyList = false;

        this.$scope.$watch(() => this.sizeValue, () => {
            if (!this.target || !this.sizeValue) return;
            this.target.sizeLimit = this.utilsService.toBytes(this.sizeValue, this.sizeUnit['value']);
        });

        this.$scope.$watch(() => this.sizeUnit, () => {
            if (!this.target || !this.sizeUnit) return;
            this.target.sizeLimit = this.utilsService.toBytes(this.sizeValue, this.sizeUnit['value']);
        });

        this.$scope.$watch(() => this.selectedTarget, () => {
            if (!this.target || this.selectedTarget.length === 0) return;
            this.target.targetName = this.selectedTarget[0].label;
            this.target.resourceGroupName = this.selectedTarget[0].value;
        });

        this.configTargetsTable();
    }

    $onInit() {
        if (!this.principalService.isTokenPersisted()) return;
        this.actionButtons = [
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: this.saveTarget.bind(this),
                isDisabled: () => this.dialogForm && !this.dialogForm.$valid || ((this.selectedTarget.length === 0 && this.searchTgt === '') && !this.isEdit),
                id: 'targets-new-edit-save'
            }
        ];
        this.sizeUnitList = [
            { id: 1, label: this.$filter('translate')('common.unit.default.size.mib'), value: 'mib' },
            { id: 2, label: this.$filter('translate')('common.unit.default.size.gib'), value: 'gib' },
            { id: 3, label: this.$filter('translate')('common.unit.default.size.tib'), value: 'tib' }
        ];
        this.targetList = [];
        this.searchTgt = "";
    }

    async onOpen() {
        this.selectedTarget = []
        this.closeId = { close: 'targets-new-close', closeIcon: 'targets-new-close-icon' };
        if (this.target) {
            this.isEdit = true;
            this.helpId = 'target-edit';
            this.modalTitle = this.$filter('translate')('target.edit.title');
            const resp = await this.targetsPersistence.getTarget(this.target.uuid);
            this.target = Target.fromRaw(resp.data.entities[0]);
            this.busy = false;
        } else {
            this.isEdit = false;
            this.helpId = 'target-add';
            this.modalTitle = this.$filter('translate')('target.new.title');
            this.target = new Target();
            this.loadTargets()
        }
        this.sizeValue = this.target.sizeLimit;
        if (this.sizeValue > 0) {
            const result = this.utilsService.fromBytes(this.sizeValue);
            this.sizeUnit = this.sizeUnitList.filter(s => s.value === result['unit'])[0];
            this.sizeValue = result['value'];
        }
    }


    async loadTargets() {
        this.busy = true;
        const targets = await this.targetsPersistence.getAzureTargets(this.searchTgt);
        this.targetList = targets.map((b, index) => ({
            uuid: index,
            label: b.value,
            value: b.label
        }));

        this.emptyList = this.targetList.length === 0 ? true : false;

        this.busy = false;
    }

    configTargetsTable() {
        this.targetTableColumnNames = [
            this.$filter('translate')('target.edit.form.aws.targetName.label'),
        ];
    }


    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: true,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('6%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('94%');

        this.$timeout(() => {
            this.grid.tableName = this.grid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    saveTarget() {
        // if edit then update
        if (this.isEdit) {
            const updateTargetRequest = {
                sizeLimit: this.target.sizeLimit
            };
            this.busy = true;
            this.targetsPersistence.update(updateTargetRequest, this.target.uuid).then(resp => {
                this.notificationService.pop(resp.data.message);
                this.busy = false
                this.onCloseModal();
            });
        }
        // if add then save
        else {
            if (this.selectedTarget.length === 0) {
                const addTargetRequest = {
                    name: this.searchTgt,
                    sizeLimit: this.target.sizeLimit
                };

                this.busy = this.targetsPersistence.saveWithName(addTargetRequest).then(resp => {
                    this.notificationService.pop(resp.data.message);
                    this.onCloseModal(true);
                });
            }
            else {
                const addTargetRequest = this.selectedTarget.map((target) => {
                    return {
                        resourceGroupName: target.value,
                        name: target.label,
                        sizeLimit: this.target.sizeLimit
                    }
                });

                this.busy = this.targetsPersistence.save(addTargetRequest).then(resp => {
                    this.notificationService.pop(resp.data.message);
                    this.onCloseModal(true);
                });
            }
        }
    }

    onCloseModal(isSave) {
        this.searchTgt = '';
        this.sizeValue = '';
        this.sizeUnit = '';
        // this.selectedTarget = [];
        this.showModal = false;
        if (isSave) {
            this.onClose({ target: this.target });
        } else {
            this.onClose();
        }
        this.target = null;
    }
}

TargetAddEditDialogController.$inject = ['$scope', '$filter', '$timeout', 'utilsService', 'principalService', 'notificationService', 'targetsPersistence', 'storageService'];

const targetAddEditDialogComponent = {
    template: require('./targetAddEditDialog.template.html'),
    bindings: {
        showModal: '=',
        target: '<',
        onClose: '&',
    },
    controller: TargetAddEditDialogController,
};

module.exports = targetAddEditDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/targets/dialogs/targetAddEditDialog/targetAddEditDialog.component.js